import React from 'react';
import { X, AlertTriangle } from 'lucide-react';

interface CloseConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  challengeTitle: string;
}

export function CloseConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  challengeTitle
}: CloseConfirmationModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-gradient-to-br from-[#1C1C1C] to-[#888888] shadow-lg w-full max-w-md text-white">
        <div className="p-6 border-b border-white/10">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              <AlertTriangle className="w-6 h-6 text-amber-400" />
              <h2 className="text-2xl text-white font-brand font-light italic">Close Challenge</h2>
            </div>
            <button 
              onClick={onClose}
              className="text-white/70 hover:text-white transition-colors p-1 hover:bg-white/10 rounded-full"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
        </div>

        <div className="p-6 space-y-4">
          <div className="p-4 bg-amber-500/10 backdrop-blur-sm rounded-xl border border-amber-500/20">
            <p className="text-white">
              Are you sure you want to close <span className="font-semibold">"{challengeTitle}"</span>?
            </p>
            <p className="mt-2 text-sm text-white/80">
              This action cannot be undone. Participants will have 7 days to complete the challenge before it's archived.
            </p>
          </div>
        </div>

        <div className="p-6 border-t border-white/10 bg-white/5">
          <div className="flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-6 py-2 border border-white/20 rounded-xl hover:bg-white/10 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="px-6 py-2 bg-amber-600 hover:bg-amber-700 text-white rounded-xl transition-colors"
            >
              Close Challenge
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}